import styled from 'styled-components';

import { H2, H1, Description } from '~/src/ui/typography';

export const RootBox = styled.div`
  box-sizing: border-box;
  font-family: 'DM Sans', sans-serif;
  color: #475266;
  background-color: #F8F8F8;
  display: flex;
  justify-content: center;

  & * {
    box-sizing: border-box;
  }
`;

export const RootLayout = styled.div`

  @media (min-width: 480px) {
    max-width: 480px;
    padding: 0 10px 58px;
  }

  @media (min-width: 320px) {
    width: 100%;
    padding-bottom: 42px;
  }

  @media (min-width: 960px) {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: flex-start;
    align-content: flex-start;
    max-width: 960px;
    max-height: 1400px;
    padding: 32px 0 48px;
  }

  @media (min-width: 1200px) {
    max-width: 1200px;
    padding: 56px 0;
  }
`;

export const RootWrapper = styled.div`
  padding: 16px 0;

  @media (min-width: 1200px) {
    padding: 20px;
  }
`;

export const Wrapper = styled.div``;

export const RootContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 32px 30px 16px;

  @media (min-width: 480px) {
    padding: 32px 0 16px;
  }

  @media (min-width: 960px) {
    width: 50%;
    padding: 0 40px 0 10px;
  }

  @media (min-width: 1200px) {
    padding: 0;
  }

  & ${H1} {
    margin: 10px 0;

    @media (min-width: 1200px) {
      margin: 20px 0 10px;  
    }
  }

  & ${Description} {
    margin: 0 0 10px;

    @media (min-width: 1200px) {
      margin: 10px 0 20px;  
    }
  }
`;

export const RootForm = styled.div`
  padding: 40px 48px;
  background: #FFFFFF;
  width: 580px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.08), 0 20px 30px rgba(0, 0, 0, 0.12);
  border-radius: 16px;
  order: 3;

  @media (max-width: 1199px) {
   padding: 56px 48px;
   width: 470px;
  }

  @media (max-width: 959px) {
   width: 100%;
  }

  @media (max-width: 480px) {
    padding: 40px 30px;
    box-shadow: none;
    border-radius: 0;
  }

  & ${H2} {
    color: #969CA3;
    margin: 0 0 24px;
  }
`;

RootBox.displayName = 'RootBox';
RootLayout.displayName = 'RootLayout';
RootWrapper.displayName = 'RootWrapper';
RootContent.displayName = 'RootContent';
RootForm.displayName = 'RootForm';
